import { render, staticRenderFns } from "./FiscaisPorDias.vue?vue&type=template&id=2dbcac08&lang=pug&"
import script from "./FiscaisPorDias.vue?vue&type=script&lang=js&"
export * from "./FiscaisPorDias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports